module.exports = __webpack_public_path__ + "static/media/figma.6e4b59f2.jpg";